import { render, staticRenderFns } from "./BtnExcluirOutraEmpresa.vue?vue&type=template&id=257da770"
import script from "./BtnExcluirOutraEmpresa.vue?vue&type=script&lang=js"
export * from "./BtnExcluirOutraEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports